import { render } from "./HrAnnouncements.vue?vue&type=template&id=3229058b&scoped=true"
import script from "./HrAnnouncements.vue?vue&type=script&lang=js"
export * from "./HrAnnouncements.vue?vue&type=script&lang=js"

import "./HrAnnouncements.vue?vue&type=style&index=0&id=3229058b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3229058b"]])

export default __exports__